import { createFileRoute } from "@tanstack/react-router";
import { Loading } from "@/layouts/loading";
import Component from "./-components/component";
import { pharmacyClient } from "@/connect";
import { ShiftSummaryResponse } from "@/gen/shifts/shift_summary_pb";

const API_URL = import.meta.env.VITE_API_URL as string;

export const Route = createFileRoute(
  "/(inventory)/branch/_layout/reports/shift-history/shift-summary/$shiftId/"
)({
  component: Component,
  loader: async ({ params }): Promise<ShiftSummaryResponse> => {
    try {
      const shiftInfo = await pharmacyClient.shiftSummary({
        shiftId: params.shiftId,
      })
      return shiftInfo
    } catch (error) {
      console.error("Error fetching shift summary report:", error);
      throw new Error("Failed to fetch shift summary report");
    }
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
});
